export interface TokenDisplay {
  symbol?: string
  logoUri?: string | null
}

interface TokenPairLogoProps {
  token0?: TokenDisplay | null
  token1?: TokenDisplay | null
  size?: 'sm' | 'md' | 'lg'
}

export function TokenPairLogo({ token0, token1, size = 'md' }: TokenPairLogoProps) {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
  }

  const TokenLogo = ({ token, isSecondary = false }: { token?: TokenDisplay | null; isSecondary?: boolean }) => (
    <div
      className={`${
        sizeClasses[size]
      } rounded-full bg-kodiak-card-secondary border-2 border-kodiak-bg flex items-center justify-center overflow-hidden ${
        isSecondary ? '-ml-2' : 'z-10 relative'
      }`}
    >
      {token?.logoUri ? (
        <img
          src={token.logoUri}
          alt={token.symbol || 'Token'}
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement
            target.style.display = 'none'
            target.nextElementSibling?.classList.remove('hidden')
          }}
        />
      ) : null}
      <div className={`text-xs font-medium text-kodiak-text-secondary ${token?.logoUri ? 'hidden' : ''}`}>
        {token?.symbol?.charAt(0) || '?'}
      </div>
    </div>
  )

  return (
    <div className="flex items-center">
      <TokenLogo token={token0} />
      <TokenLogo token={token1} isSecondary />
    </div>
  )
}
